import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { VideoModule } from '@gelato-api-ui/sdk/src/lib/shared/video/video.module';
import { AssetsPathPipe } from '@gelato-api-ui/sdk/src/lib/pipes/assets-path.pipe';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule, VideoModule, AssetsPathPipe],
  selector: 'gd-single-video-fullscreen',
  templateUrl: './single-video-fullscreen.component.html',
  styleUrls: ['./single-video-fullscreen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleVideoFullscreenComponent {
  @Input() videoId: string;
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
